import React from 'react';

const MarvelCategory = () => {
    return(
        <div className='cards-categories'>
            <div>
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/02A21AB49E86AF5C9B2088B8DD4AFF0807B66FE8888FCAD30BEE9763415AE8FD/scale?width=400&aspectRatio=1.78&format=jpeg" alt="" />
            </div>

            <div>
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/80DEEEA10A08FF832B61E1FEED02FC3A20598752CE5F793B1B84799ED653AFA1/scale?width=400&aspectRatio=1.78&format=jpeg" alt="" />
            </div>
                
            <div>
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/D048AD2A609B520FA01F7385BE503FB5103D6DC8AB95349CA81606BAB099DB84/scale?width=400&aspectRatio=1.78&format=jpeg" alt="" />
            </div>
                
            <div>
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/4B606EF36712FE9A3C3DE05E7C9FCCB142B725411857BA94AF0DD0F6860A183B/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal" alt="" />
            </div>
        </div>
    )
}

export default MarvelCategory;